import { CancelEnrollmentInput } from '../../lib/types/models/enrollment/enrollment-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelEnrollment({ id, ...data }: IdInput<CancelEnrollmentInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.cancelEnrollment.url, { id }))
    .post<unknown, CancelEnrollmentInput>(data)
}
